module.exports = __webpack_public_path__ + "img/zzsh_banne_xn.ac2040b5.png";